import { useMutation } from '@tanstack/react-query';

import API from 'configs/API';
import { axiosPost } from 'utils/apis/axios';

const unLikeArtwork = async (id) => {
  const { data } = await axiosPost(false, API.ARTWORK.UN_LIKE_ARTWORK(id));
  return data;
};

const useUnLikeArtwork = () => {
  return useMutation({
    mutationFn: unLikeArtwork,
  });
};

export default useUnLikeArtwork;
